<div class="mb-5">

 <form  [formGroup]="filterForm" >

  <div class="row">
    <!--  filter Done -->
    <div class="col-md-6 d-flex justify-content-between align-items-center my-2" *ngIf="showSearch">
      <div class="form w-100">
        <i class="fa fa-search"></i>
        <input type="text"  #searchInput (keydown.enter)="search($event)" class="form-control form-input" for [placeholder]="searchPlaceholder" >
      </div>
    </div>

    <!--  filter Done -->
    <div class="col-md-3 my-2 d-flex justify-content-between align-items-center" *ngIf="showPublisher">
      <ng-select formControlName="publisher"  [placeholder]=" 'الناشر'" *ngIf="PublishersArray.length >0">
        <ng-option *ngFor="let item of PublishersArray" [value]="item?.id">{{item?.flatData?.publishername}}</ng-option>
      </ng-select>
    </div>


    <!-- <div class="col-md-3 my-2 d-flex justify-content-between align-items-center" *ngIf="showAuthors">
      <ng-select formControlName="authors" [placeholder]=" 'المؤلفين'">
        <ng-option>{{""}}</ng-option>
      </ng-select>
    </div> -->

    <!--  filter Done -->
    <div class="col-md-12 my-2 d-flex justify-content-between align-items-center" *ngIf="showAllyears">
      <ng-select formControlName="allyears" [placeholder]=" 'كل الاعوام'">
        <ng-option *ngFor="let item of allYearsArray" [value]="item">{{item}}</ng-option>
      </ng-select>
    </div>

    <div class="col-md-3 my-2 d-flex justify-content-between align-items-center" *ngIf="showYears">
      <ng-select [(ngModel)]="department" [placeholder]="year ? '' : 'اختر العام...'">
        <ng-option>{{""}}</ng-option>
      </ng-select>
    </div>
    <!--  filter Done -->
    <div class="col-md-3 my-2 d-flex justify-content-between align-items-center " *ngIf="showWriter">
      <ng-select  formControlName="witerid"  [placeholder]=" 'اسم الكاتب'">
        <ng-option *ngFor="let item of writersArray" [value]="item?.id"  >{{item?.flatData?.writername}}</ng-option>
      </ng-select>
    </div>

    <!--  filter Done -->
    <div class="col my-2 d-flex justify-content-between align-items-center" *ngIf="showDate">
      <div class="w-100 col-xs-12 col-12 col-md-4 form-group ">
        <input class="form-control date-input" formControlName="fromtodate" #drp="bsDaterangepicker" [bsConfig]="bsConfig"  bsDaterangepicker 
          placeholder=" {{ 'التاريخ (من / الي)' }}">
      </div>
      <div class="col-xs-12 col-12 col-md-3 form-group mb-3">
      </div>
    </div>

    <div class="col-md-3 my-2 d-flex justify-content-between align-items-center" *ngIf="showTrainer">
      <ng-select  formControlName="lectureid"  [placeholder]="trainer ? '' : 'اسم المدرب...'">
        <ng-option *ngFor="let item of lecturesArray" [value]="item?.id" >{{item?.flatData?.lecturername}}</ng-option>
      </ng-select>
    </div>

  </div>

 </form>

</div>